//ServerName

import {Container, Title, ExpandIcon} from './styles'



const ServerName: React.FC = () => {
    return(
        <Container>
            <Title>Servidor do Erick</Title>
            <ExpandIcon/>
        </Container>
    )
};

export default ServerName;